import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BlockTitle from '../typography/BlockTitle';
import Video from './Video';
import VideoOverlay from '../VideoOverlay';

const Videos = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0 0 0;

  @media ${p => p.theme.media.largePhone} {
    flex-direction: column;
  }
`;

const VideoWrapper = styled.div`
  display: flex;
  width: 31%;

  @media ${p => p.theme.media.largePhone} {
    width: 100%;
  }
`;

const VideoList = ({ title, videos }) => {
  const [currentVideo, setCurrentVideo] = useState();

  function setVideo(id) {
    return () => setCurrentVideo(id);
  }

  return (
    <Fragment>
      <VideoOverlay
        id={currentVideo}
        toggleOverlay={setVideo(null)}
        show={Boolean(currentVideo)}
      />
      <BlockTitle>{title}</BlockTitle>
      <Videos>
        {videos.map((a, i) => (
          <VideoWrapper key={i}>
            <Video
              showVideo={setVideo(a.id)}
              description={a.description}
              heading={a.title}
              imageUrl={[
                a.thumbnail,
                `https://img.youtube.com/vi/${a.id}/0.jpg`
              ]}
            />
          </VideoWrapper>
        ))}
      </Videos>
    </Fragment>
  );
};

VideoList.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string,
      thumbnail: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired,
  title: PropTypes.string.isRequired
};

export default VideoList;
